import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../baseQuery';
import { MARKETPLACE_API } from '@/constants/residents/marketplaceConstants';
import { CreateReportRequest } from './types';

// ============================================================================
// Reports API
// ============================================================================

export const reportsApi = createApi({
  reducerPath: 'marketplaceReportsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    /**
     * Report a listing or conversation
     */
    createReport: builder.mutation<void, CreateReportRequest>({
      query: (data) => ({
        url: MARKETPLACE_API.reports.base,
        method: 'POST',
        body: {
          ...(data.listingId && { listingId: Number(data.listingId) }),
          ...(data.conversationId && { conversationId: Number(data.conversationId) }),
          ...(data.reportedUserId && { reportedUserId: Number(data.reportedUserId) }),
          reason: data.reason,
          description: data.description,
        },
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useCreateReportMutation,
} = reportsApi;

